import { createContext } from "react";

export const LevelContext = createContext({});